export default "<span class=\"planningaction-tooltip\">\n  <ng-content></ng-content>\n</span>\n";